import React from "react";
import { inject, observer } from "mobx-react";
import InsuredData from "../../sharedComponents/insureds/insuredData/insuredData";
import { ClientStore } from "../../../stores/clientStore";
import { ClientModel } from "../../../helpers/client";

interface InsuredsProps {
    clientStore?: ClientStore;
    disabled: boolean;
    displayAddressForm: boolean;
    className: string;
}

@inject("clientStore")
@observer
export default class Insureds extends React.Component<InsuredsProps> {
    public render() {
        return (
            <>
                {this.renderInsuredsData()}
            </>
        );
    }

    private renderInsuredsData() {
        const insureds = this.props.clientStore!.insureds;

        return insureds
            .sort((insured1, insured2) => this.compareInsureds(insured1, insured2))
            .map((insured, i) => (
                <InsuredData key={"insured_" + insured.id}
                    client={insured}
                    insuredIndex={i}
                    disabled={this.props.disabled || insured.insurer}
                    className={this.props.className}
                    displayAddressForm={this.props.displayAddressForm}
                    disabledAddress={insured.insurer}
                />
            ));
    }

    private compareInsureds(insured1: ClientModel, insured2: ClientModel): number {
        return (+insured2.insurer - +insured1.insurer) || (+this.emptyData(insured1) - +this.emptyData(insured2));
    }

    private emptyData(insured: ClientModel) {
        return insured.firstName.value === ""
            && insured.lastName.value === ""
            && insured.companyName.value === ""
            && insured.pesel.value === ""
            && insured.regon?.value === ""
            && insured.nip?.value === "";
    }
}
